import React, { useState } from "react"
import {
  Table,
  Modal,
  Card,
  Icon,
  Dimmer,
  Loader,
  Button,
} from "semantic-ui-react"
import { useTranslation } from "react-i18next"
import OrderModalComponent from "../components/OrderModalComponent"
import ReactExport from "react-export-excel"
import { cutOnUnicode } from "../utils/logical"
import SignXml from "../components/SignXml"
import { apiGet, apiPost } from "../utils/apiConnector"
import { invoiceXlsxApi, signXmlApi } from "../config/apiUrls"
import { useDispatch, useSelector } from "react-redux"

const ExcelFile = ReactExport.ExcelFile
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn

const TableHolder = (props) => {
  const [modal, setModal] = useState(false)
  const { config } = props
  const { t } = useTranslation()
  const { profile } = useSelector((state) => ({ profile: state.profile }))
  const formatDate = (dt) => {
    const months = [
      "",
      "january",
      "february",
      "march",
      "april",
      "may",
      "june",
      "july",
      "august",
      "september",
      "october",
      "november",
      "december",
    ]
    const parsedString = dt.split("-")
    const year = parseInt(parsedString[0])
    const month = parseInt(parsedString[1])
    const day = parseInt(parsedString[2].slice(0, 2))
    const time = parsedString[2].slice(3, 8)
    return (
      <>
        <div>
          <p>
            {day} {t(months[month])} {year} {t("in")} {time}
          </p>
        </div>
      </>
    )
  }
  const renderHeaders = () => {
    return (
      <>
        <Table.Header>
          <Table.Row>
            {config.headers.map((q) => (
              <>
                <Table.HeaderCell>{t(q.title)}</Table.HeaderCell>
              </>
            ))}
          </Table.Row>
        </Table.Header>
      </>
    )
  }
  const renderRows = () => {
    return (
      <>
        <Table.Body>
          {config.data.map((q) => (
            <>
              <Table.Row
                onClick={() => {
                  if (config.inner) {
                    setModal(true)
                  }
                  if (config.onClick) {
                    config.onClick(q.id)
                  }
                }}
              >
                {config.headers.map((w) => {
                  if (typeof q[w.name] === "boolean") {
                    return (
                      <>
                        <Table.Cell>
                          <div
                            style={{ display: "flex", alignItems: "center" }}
                          >
                            {q[w.name] ? (
                              <>
                                <Icon
                                  name="checkmark"
                                  color="green"
                                  size="large"
                                />
                              </>
                            ) : (
                              <>
                                <Icon name="close" color="red" size="large" />
                              </>
                            )}
                          </div>
                        </Table.Cell>
                      </>
                    )
                  } else if (w.name === "dt") {
                    return (
                      <>
                        <Table.Cell>{formatDate(q[w.name])}</Table.Cell>
                      </>
                    )
                  }
                  return (
                    <>
                      <Table.Cell>
                        {q[w.name] !== undefined
                          ? //w.name === "code"
                            //? cutOnUnicode(q[w.name])
                            //:
                            q[w.name]
                          : ""}
                      </Table.Cell>
                    </>
                  )
                })}
              </Table.Row>
            </>
          ))}
        </Table.Body>
      </>
    )
  }
  const renderModal = () => {
    return (
      <>
        <Modal
          open={modal}
          onClose={() => {
            setModal(false)
          }}
          style={{ marginTop: "-40vh", height: "max-content" }}
        >
          <Card fluid>
            <Card.Content>
              {config.custom === "order" ? (
                <>
                  <OrderModalComponent
                    data={config.inner.data}
                    isLoading={
                      config.inner.isLoading ? config.inner.isLoading() : false
                    }
                    setModal={setModal}
                  />
                </>
              ) : (
                <>
                  <TableHolder config={config.inner} />
                </>
              )}
            </Card.Content>
          </Card>
        </Modal>
      </>
    )
  }
  return (
    <>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 10,
        }}
      >
        <h3>{t(config.title)}</h3>
        <div
          style={{ display: config.custom === "documents" ? "flex" : "none" }}
        >
          <Button
            // positive
            content={t("Предпросмотр XML")}
            onClick={() => {
              config.getXmlPreview()
            }}
          />
        </div>
      </div>
      <div style={{ display: "none" }}>
        <ExcelFile
          filename={config.fname ? config.fname : "temp"}
          element={
            <Button
              content={t("Export to excel")}
              style={{ marginTop: 10, marginBottom: 10 }}
              color="yellow"
            />
          }
        >
          <ExcelSheet
            data={config.data}
            name={config.title ? config.title : "temp"}
          >
            {config.headers.map((el) => {
              return (
                // eslint-disable-next-line react/jsx-key
                <ExcelColumn label={t(el.title)} value={el.title} />
              )
            })}
          </ExcelSheet>
        </ExcelFile>
      </div>
      <Dimmer active={config.isLoading ? config.isLoading() : false} inverted>
        <Loader />
      </Dimmer>
      <div style={{ overflowX: "scroll" }}>
        <Table celled unstackable sortable compact fluid>
          {renderHeaders()}
          {renderRows()}
        </Table>
        {renderModal()}
      </div>
      <div
        style={{
          display: config.custom === "documents" ? "flex" : "none",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 10,
        }}
      >
        <div style={{ display: "none" }}>
          <Button
            content={t("Export to excel")}
            color="gray"
            onClick={() => {
              fetch(invoiceXlsxApi + "?invoiceId=" + config.id, {
                headers: { Authorization: "Bearer " + profile.token },
              })
                .then((response) => response.arrayBuffer())
                .then((data) => {
                  console.log(data)
                  const blob = new Blob([data], {
                    type:
                      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,",
                  })
                  const a = document.createElement("a")
                  a.href = URL.createObjectURL(blob)
                  a.download = config.fname
                  a.click()
                })
            }}
          />
        </div>
        <div style={{ display: "block" }}>
          <ExcelFile
            filename={config.fname ? config.fname : "temp"}
            element={
              <Button
                content={t("Export to excel")}
                style={{ marginTop: 10, marginBottom: 10 }}
                color="gray"
              />
            }
          >
            <ExcelSheet
              data={config.data}
              name={config.title ? config.title : "temp"}
            >
              {/* {config.headers.map((el) => {
                return (
                  // eslint-disable-next-line react/jsx-key
                  <ExcelColumn label={t(el.title)} value={el.title} />
                )
              })} */}
              <ExcelColumn value={"code"} />
            </ExcelSheet>
          </ExcelFile>
        </div>
        {
          // <Button positive content={t("signWithEcp")} />
        }
        {
          <SignXml
            getXmlData={config.getXmlData}
            data={config.ldata}
            uuid={config.luuid}
            token={config.token}
            setToken={config.setToken}
            sendData={(authData, content, signature) => {
              const id = config.id
              if (
                config.id &&
                config.ldata &&
                config.luuid &&
                authData &&
                content &&
                signature
              ) {
                apiPost(signXmlApi, {
                  id,
                  uuid: config.luuid,
                  data: config.ldata,
                  authData,
                  content,
                  signature,
                })
                  .onOk((res) => {
                    console.log(res.data.response)
                    config.setToken(res.data.response.token)
                    alert("Подписано")
                  })
                  .onFail(() => {})
                  .afterAll(() => {})
                  .startSingle()
              }
            }}
          />
        }
      </div>
    </>
  )
}

export default TableHolder
